import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const PhrasesPage = () => {
  const columns = [
    { key: 'shortcut', label: 'Shortcut' },
    { key: 'category', label: 'Category' },
    { key: 'phrase', label: 'Phrase Text' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'shortcut', label: 'Shortcut Code', type: 'text', required: true },
    { key: 'category', label: 'Category', type: 'select', required: true, options: [
      { value: 'Vital Signs', label: 'Vital Signs' },
      { value: 'Assessment', label: 'Assessment' },
      { value: 'Interventions', label: 'Interventions' },
      { value: 'Education', label: 'Patient Education' },
      { value: 'Communication', label: 'Communication' },
      { value: 'Goals', label: 'Goals' },
      { value: 'Other', label: 'Other' },
    ]},
    { key: 'phrase', label: 'Phrase Text', type: 'textarea', required: true, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', shortcut: '.VSN', category: 'Vital Signs', phrase: 'Vital signs within normal limits. Patient denies pain or discomfort.', active: 'Yes' },
    { id: '2', shortcut: '.LUNGCL', category: 'Assessment', phrase: 'Lungs clear to auscultation bilaterally. No adventitious sounds noted.', active: 'Yes' },
    { id: '3', shortcut: '.HEARTRRR', category: 'Assessment', phrase: 'Heart sounds regular rate and rhythm. No murmurs, gallops, or rubs.', active: 'Yes' },
    { id: '4', shortcut: '.WOUNDGR', category: 'Assessment', phrase: 'Wound bed appears granulated with healthy tissue. No signs of infection.', active: 'Yes' },
    { id: '5', shortcut: '.MEDREV', category: 'Interventions', phrase: 'Medication review completed. Patient verbalizes understanding of all medications, dosages, and administration times.', active: 'Yes' },
    { id: '6', shortcut: '.FALLPREV', category: 'Education', phrase: 'Fall prevention education provided. Discussed importance of clear pathways, adequate lighting, and use of assistive devices.', active: 'Yes' },
    { id: '7', shortcut: '.MDCALL', category: 'Communication', phrase: 'Physician notified of patient status. Verbal orders received and read back for confirmation.', active: 'Yes' },
    { id: '8', shortcut: '.GOALPROG', category: 'Goals', phrase: 'Patient making progress toward goals. Continue current plan of care.', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Phrases"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Phrase"
      formFields={formFields}
      apiEndpoint="/setup/phrases"
    />
  );
};

export default PhrasesPage;
